import React from "react";
import { Form } from "react-bootstrap";

function CollageRegistration_step_5({ register, errors }) {
  return (
    <>
      <h5 className="step-heading">E. Internship Coordinator</h5>

      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                {...register("i_c_f_name", {
                  required: " First Name is required",
                })}
                placeholder=" First Name"
              />
              {errors.i_c_f_name && (
                <Form.Text className="text-danger">
                  {errors.i_c_f_name.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                {...register("i_c_l_name", {
                  required: "Last Name is required",
                })}
                placeholder="Last Name"
              />
              {errors.i_c_l_name && (
                <Form.Text className="text-danger">
                  {errors.i_c_l_name.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>School Email (non-personal)</Form.Label>
              <Form.Control
                type="text"
                {...register("i_c_email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
                placeholder="Email"
              />
              {errors.i_c_email && (
                <Form.Text className="text-danger">
                  {errors.i_c_email.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="number"
                {...register("i_c_contact_no", {
                  required: "Phone no is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Please enter a valid 10-digit phone number",
                  },
                })}
                placeholder="Phone no"
              />
              {errors.i_c_contact_no && (
                <Form.Text className="text-danger">
                  {errors.i_c_contact_no.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Check label="I declare the authenticity and academic responsibility of the information" />
          </div>
        </div>
      </div>
    </>
  );
}

export default CollageRegistration_step_5;
